export function extractSkuFromRecipeCode(code) {
  return code && code.slice(0, 4)
}
